module.exports = __webpack_public_path__ + "static/achieveIcon_0-d13dee9805f42755e1f613d17f0270ac.png";